import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CancelButton as CancelButtonBase } from '../button/CancelButton';

type Props = {
  className?: string;
  size?: 'sm' | 'lg';
  onClick?: () => void;
};

export const CancelButton: React.FC<React.PropsWithChildren<Props>> = ({
  size,
  className,
  children,
  onClick,
}) => {
  const {
    reset,
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <CancelButtonBase
      disabled={isSubmitting}
      size={size}
      label={undefined}
      className={['lift', className].join(' ')}
      onClick={(event) => {
        event.preventDefault();
        if (onClick) {
          onClick();
        } else {
          reset();
        }
      }}>
      {children}
    </CancelButtonBase>
  );
};

export default CancelButton;
